<template>
  <div :id="`top-providers-${section}-section`">
    <h3
      v-if="title"
      class="subtitle1 flex flex-col md:flex-row items-center justify-center border-t border-gray-400 pt-10 mt-10 md:mb-5 max-w-4xl mx-auto"
    >
      <svg role="presentation" focusable="false" tabindex="-1" v-if="section === 'bank'"
        class="icon icon-lg mb-2 md:mr-4"
         
        alt=""
        svg-inline
       xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32">
  <path fill="#7CC242" d="m6.7 14.7-.1.9a39 39 0 0 0-.1 1.2 49 49 0 0 0 .2 9.2l13.6-.5s-.5-11.8-13.6-10.8" opacity=".6"/>
  <path fill="#575758" d="M30 16a1 1 0 0 0 1-1v-4a1 1 0 0 0-.5-.8l-14-9a1 1 0 0 0-1 0l-14 9a1 1 0 0 0-.5.8v4a1 1 0 0 0 1 1h3v9H2a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h28a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-3v-9zM16 3.2 26.6 10H5.4zM29 27v2H3v-2zM7 25v-9h3v9zm5 0v-9h8v9zm10 0v-9h3v9zM3 14v-2h26v2z"/>
</svg>
      <svg role="presentation" focusable="false" tabindex="-1" v-else-if="section === 'cash'"
        class="icon icon-lg mb-2 md:mr-4"
         
        alt=""
        svg-inline
       fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 33 24">
<path opacity=".6" d="M.92 4.98v11.36h15.9S16.19 3.08.93 4.98Z" fill="#7CC242"/>
<path d="M24.68 4.58a2.59 2.59 0 0 1-1.57-1.57h1.57v1.57Zm0 7.15a4.33 4.33 0 0 0-3.37 3.37H5.6a4.33 4.33 0 0 0-3.36-3.37V6.38A4.33 4.33 0 0 0 5.59 3h15.72a4.33 4.33 0 0 0 3.37 3.37v5.35Zm0 3.37H23.1c.26-.73.84-1.3 1.57-1.57v1.57Zm-22.45 0v-1.57c.73.26 1.3.84 1.56 1.57H2.23Zm0-12.09h1.56c-.26.73-.83 1.3-1.56 1.57V3.01ZM25.54 1.3H1.36a.86.86 0 0 0-.86.86v13.81c0 .48.39.87.86.87h24.18c.48 0 .86-.39.86-.87V2.15a.86.86 0 0 0-.86-.86Z" fill="#575758"/>
<path d="M13.02 7.33h2.16a.86.86 0 1 0 0-1.73h-.86v-.86a.86.86 0 1 0-1.73 0v.9a2.16 2.16 0 0 0 .43 4.28h.86a.43.43 0 0 1 0 .86h-2.16a.86.86 0 1 0 0 1.73h.87v.86a.86.86 0 1 0 1.72 0v-.9a2.16 2.16 0 0 0-.43-4.28h-.86a.43.43 0 0 1 0-.86Z" fill="#575758"/>
<path fill="#fff" d="M6.92 7.7h25.05v14.66H6.92z"/>
<path opacity=".6" d="M7.02 11.08v11.36h15.9s-.64-13.26-15.9-11.36Z" fill="#7CC242"/>
<path d="M30.77 10.68A2.59 2.59 0 0 1 29.2 9.1h1.57v1.57Zm0 7.15a4.33 4.33 0 0 0-3.36 3.37H11.69a4.33 4.33 0 0 0-3.37-3.37v-5.36a4.33 4.33 0 0 0 3.37-3.36H27.4a4.33 4.33 0 0 0 3.36 3.36v5.36Zm0 3.37H29.2c.27-.73.84-1.31 1.57-1.57v1.57Zm-22.45 0v-1.57c.73.26 1.3.84 1.57 1.57H8.32Zm0-12.1H9.9c-.26.74-.84 1.31-1.57 1.58V9.1Zm23.32-1.72H7.46a.86.86 0 0 0-.86.86v13.82c0 .48.38.86.86.86h24.18c.47 0 .86-.38.86-.86V8.24a.86.86 0 0 0-.86-.86Z" fill="#575758"/>
<path d="M19.12 13.43h2.15a.86.86 0 0 0 0-1.73h-.86v-.86a.86.86 0 0 0-1.73 0v.9a2.16 2.16 0 0 0 .44 4.28h.86a.43.43 0 0 1 0 .86h-2.16a.86.86 0 1 0 0 1.73h.86v.86a.86.86 0 1 0 1.73 0v-.9a2.16 2.16 0 0 0-.43-4.28h-.86a.43.43 0 0 1 0-.86Z" fill="#575758"/>
</svg>
      {{ title }}
    </h3>
    <ul
      class="flex gap-x-4 py-5 px-2 -mx-2 mb-4 overflow-x-auto"
      :class="{
        'justify-center': topProviders.length === 1,
        'md:justify-center': topProviders.length === 2,
        'lg:justify-center': topProviders.length === 3,
      }"
    >
      <li
        v-for="{ provider, metrics } of topProviders"
        :key="provider.slug"
        class="min-w-64 max-w-sm box-container rounded-6 flex-1 flex flex-col relative"
      >
        <div class="h-20">
          <div
            class="bg-blue-800 text-white text-18 text-left font-semibold py-1 pl-4 pr-24"
            :style="{
              backgroundColor: provider.logo.color ?? undefined,
              color: provider.logo.contrastColor ?? undefined,
            }"
          >
            <template v-if="metrics.length === 3">
              {{ $t('top_providers.label.top') }}
            </template>
            <template v-else>
              {{ $t(`top_providers.label.${metrics[0].type}`) }}
            </template>
          </div>
        </div>
        <Component
          class="flex absolute right-2 top-2"
          :is="provider.url ? 'a' : 'span'"
          :href="provider.url"
          :title="provider.url ? $t('read_full_review') : undefined"
        >
          <ScoreCircle
            size="sm"
            :score="provider.score ? provider.score.value : undefined"
            with-a11y-title
            :provider-name="provider.name"
          />
        </Component>
        <div class="flex-1 flex flex-col m-4">
          <a
            class="block h-16 mb-6"
            :href="addAffiliateMobileAppParams(provider.affiliateUrl)"
            target="_blank"
            rel="nofollow noopener"
          >
            <BackgroundImage
              class="max-w-[200px] h-full mx-auto"
              size="contain"
              :src="provider.logo.sm"
              :alt="$t('go_to', { provider: provider.displayName })"
            />
          </a>
          <div class="flex-1" :class="{ 'md:hidden': topProviders.length === 1 }">
            <StatsBox
              v-for="{ type, percentage } in metrics"
              class="max-w-max mx-auto"
              :key="type"
              :metric="type"
              :percentage="percentage"
            />
          </div>
          <a
            class="btn btn-amber btn-sm w-full mt-3"
            target="_blank"
            rel="nofollow noopener"
            :href="addAffiliateMobileAppParams(provider.affiliateUrl)"
          >
            {{ $t('go_to', { provider: provider.displayName }) }}&nbsp;<svg role="presentation" focusable="false" tabindex="-1" class="icon icon-xs align-baseline -rotate-90"
               
              alt=""
              svg-inline
             xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 19">
  <path fill="currentColor" fill-rule="evenodd"
    d="M.8 1.18a2.26 2.26 0 0 1 3.2 0L16 13.2 28.03 1.18a2.26 2.26 0 0 1 3.2 3.2L17.6 17.97c-.88.9-2.31.9-3.2 0L.8 4.39a2.26 2.26 0 0 1 0-3.2Z"
    clip-rule="evenodd" />
</svg>
          </a>
        </div>
      </li>
      <li
        v-if="topProviders.length === 1"
        class="flex-1 max-w-xs hidden md:flex flex-col justify-evenly"
      >
        <StatsBox
          v-for="{ type, percentage } in topProviders[0].metrics"
          :key="type"
          :metric="type"
          :percentage="percentage"
        />
      </li>
    </ul>
    <p class="lead font-normal">
      <span v-html="$t('top_providers.best_of', { count: totalProviders })" />
      <a class="link dark font-normal" href="#imt-search-modal">
        {{ $t('top_providers.compare_all') }}
      </a>
    </p>
  </div>
</template>

<script lang="ts" setup>
import StatsBox from './stats-box.vue'
import type { TopProviderStats } from './getTopProviders'

defineProps<{
  section: 'overall' | 'bank' | 'cash'
  title?: string
  topProviders: TopProviderStats[]
  totalProviders: number
}>()
</script>
